module.exports = __webpack_public_path__ + "img/Checked-white.2c99202c.svg";